// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__243m1","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1obgA","obliqueLine":"membershipbadge_obliqueLine__1Vfap"};